import type { ProductListQuery, ProductSortOrder } from "./api-client";

/**
 * Port de apps/web/lib/listing-query.ts. Seule différence forcée par le
 * changement de runtime : la source des paramètres d'URL est directement
 * `URLSearchParams` (`useSearchParams()` de react-router-dom, mode SPA) plutôt
 * que le `Record<string, string | string[] | undefined>` que Next.js fournit
 * aux Server Components (`searchParams` de page.tsx) — contrat de SORTIE
 * inchangé (`Omit<ProductListQuery, "category" | "cursor">`), même logique de
 * parsing valeur par valeur.
 */
const SORT_VALUES: ProductSortOrder[] = ["popularity", "rating", "newest", "price_asc", "price_desc"];

export function parseListingSearchParams(
  sp: URLSearchParams,
): Omit<ProductListQuery, "category" | "cursor"> {
  const sortParam = sp.get("sort");
  const sort = SORT_VALUES.includes(sortParam as ProductSortOrder) ? (sortParam as ProductSortOrder) : undefined;

  const priceMinRaw = sp.get("priceMin");
  const priceMaxRaw = sp.get("priceMax");
  const ratingRaw = sp.get("rating");
  const attributes = sp.getAll("attribute");

  return {
    brand: sp.get("brand") || undefined,
    tag: sp.get("tag") || undefined,
    campaign: sp.get("campaign") || undefined,
    attribute: attributes.length ? attributes : undefined,
    priceMin: priceMinRaw ? Number(priceMinRaw) : undefined,
    priceMax: priceMaxRaw ? Number(priceMaxRaw) : undefined,
    inStock: sp.get("inStock") === "true" ? true : undefined,
    onSale: sp.get("onSale") === "true" ? true : undefined,
    rating: ratingRaw ? Number(ratingRaw) : undefined,
    sort,
  };
}
